/**
 * Pure rich-text helpers (no React) — safe for Node contract runners.
 */

export function looksLikeHtml(value) {
  return /<[a-z][\s\S]*>/i.test(String(value || "").trim());
}

/** Plain-text excerpt for cards / one-line previews (strips tags, collapses space). */
export function plainTextFromHtml(value) {
  const raw = String(value == null ? "" : value);
  if (!raw.trim()) {
    return "";
  }
  let text = raw;
  if (looksLikeHtml(text)) {
    text = text
      .replace(/<\s*br\s*\/?\s*>/gi, " ")
      .replace(/<\/\s*p\s*>/gi, " ")
      .replace(/<\/\s*div\s*>/gi, " ")
      .replace(/<\/\s*li\s*>/gi, " ")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'");
  }
  return text.replace(/\s+/g, " ").trim();
}
